@if (rejectMode) {
  <div class="width-300 am-flex-column gap-auto mla">
    <div class="form-group">
      <select class="form-control" [(ngModel)]="rejectReason" placeholder="Grund auswählen">
        <option [value]="null" disabled>Grund auswählen</option>
        @for (option of rejectOptions; track option) { <option [value]="option.value">{{ option.label }}</option> }
      </select>
    </div>
    <div class="form-group">
      <textarea class="form-control" [placeholder]="rejectPlaceholder || 'Ablehnungsgrund'" [(ngModel)]="rejectComment" maxlength="72"></textarea>
    </div>
  </div>
}

<div class="am-flex-tablet-column-reverse gap-xs">
  @if (loading) { <span class="am-flex width-120 height-36 width-tablet-full loading-animate"></span> }
  @else {
    @if (!rejectMode) { <button class="back-btn btn-full-tablet" (click)="backCallback.emit()">Zurück</button> }
    @if ( rejectMode) { <button class="back-btn btn-full-tablet" (click)="rejectMode = false">Zurück</button>  }
  }
<div class="am-flex-wrap am-flex-justify-end am-flex-1 am-flex-tablet-column gap-m" [class.events-none]="loading">
  @if (loading) {
    <span class="am-flex width-120 height-36 width-tablet-full loading-animate"></span>
    <span class="am-flex width-120 height-36 width-tablet-full loading-animate"></span>
  } @else if (rejectMode) {
    <button class="wide-btn-flex btn-full-tablet red" (click)="rejectHandler()" [disabled]="!rejectReason">{{ rejectLabel || 'Ablehnen' }}</button>
  } @else {
    @if (nested && (customerExport || internalCheck || archive) && (approveAndClose || forceApprove)) {
      <div class="relative">
        <span class="bg-white p-xs b-grey am-flex-center font-xl icon-dots hover-active" (click)="showNestedOptions = !showNestedOptions"></span>
        @if (showNestedOptions) {
          <div class="bg-white pl-xs pr-xs b-grey absolute bottom-full right-0 width-max-content text-center mb-s font-s">
            @if (customerExport) {
              <span class="am-flex-align gap-xxs p-xs hover-active" (click)="openExportModal()">
                <span class="am-flex-center font-icon-small icon-document"></span>
                <span>{{ useCaseNameShort() }} Beleg</span>
              </span>
            }
            @if (internalCheck ) {
              <span class="am-flex-align gap-xxs p-xs hover-active" (click)="internalCheckHandler()">
                <span class="am-flex-center font-icon-small icon-tick"></span>
                <span>Intern geprüft</span>
              </span>
            }
            @if (archive) {
              <span class="am-flex bt-grey"></span>
              <span class="am-flex-align gap-xxs p-xs hover-active" (click)="archiveCallback.emit()">
                <span class="am-flex-center font-icon-small icon-archive"></span>
                <span>Archivieren</span>
              </span>
            }
          </div>
        }
      </div>
    } @else {
      @if (customerExport     ) { <button class="medium-btn-flex btn-full-tablet white"                (click)="openExportModal()">{{ useCaseNameShort() }} Beleg</button> }
      @if (internalCheck      ) { <button class="medium-btn-flex btn-full-tablet white"                (click)="internalCheckHandler()">Intern geprüft</button> }
      @if (archive            ) { <button class="wide-btn-flex   btn-full-tablet orange-thin-border"   (click)="archiveCallback.emit()">Archivieren</button> }
    }

    @if (delete               ) { <button class="wide-btn-flex   btn-full-tablet red-thin-border"      (click)="deleteCallback.emit()">Ablehnen</button> }
    @if (reject && !rejectMode) { <button class="wide-btn-flex   btn-full-tablet red"                  (click)="rejectMode = true">{{ rejectLabel || 'Ablehnen' }}</button> }
    @if (rejectSingleClick    ) { <button class="wide-btn-flex   btn-full-tablet red"                  (click)="rejectHandler()"  >{{ rejectLabel || 'Ablehnen' }}</button> }

    @if (approve              ) { <button class="wide-btn-flex   btn-full-tablet blue"                 (click)="approveCallback.emit()">Freigeben</button> }
    @if (forceApprove         ) { <button class="wide-btn-flex   btn-full-tablet orange tooltip-hover" (click)="forceApproveCallback.emit()" [disabled]="disableForceApprove">Freigeben
      @if (disableForceApprove && forceApproveTooltip) { <div class="web-tooltip white medium top orange-border"><span class="tooltip-title">{{ forceApproveTooltip }}</span></div> }
      </button>
    }

    @if (nested && approveAndClose && approveAndNext) {
      <div class="am-flex-justify bg-green b-radius relative">
        <span class="am-flex-1 font-s pt-xs pb-xs pl-s pr-xs br-white color-white hover-active"        (click)="approveAndNextCallback.emit()">{{ approveAndNextLabel  || 'Freigeben & weiter' }}</span>
        <span class="am-flex-center font-xl p-xs icon-arrow-down color-white hover-active" [class.rotate]="showApproveAndClose" (click)="showApproveAndClose = !showApproveAndClose"></span>
        @if (showApproveAndClose) { <span class="bg-white b-green color-green p-xs absolute bottom-full width-full text-center mb-s font-s hover-active-blue" (click)="approveAndCloseCallback.emit()">{{ approveAndCloseLabel || 'Freigeben & schliessen' }}</span> }
      </div>
    } @else {
      @if (approveAndClose) { <button class="wide-btn-flex btn-full-tablet blue"                       (click)="approveAndCloseCallback.emit()">{{ approveAndCloseLabel || 'Freigeben & schliessen' }}</button> }
      @if (approveAndNext ) { <button class="wide-btn-flex btn-full-tablet green"                      (click)="approveAndNextCallback.emit()" >{{ approveAndNextLabel  || 'Freigeben & weiter'     }}</button> }
    }

    @if (create               ) { <button class="wide-btn-flex   btn-full-tablet blue"                 (click)="createCallback.emit()">Zur Freigabe</button> }

    @if (resolveAndClose      ) { <button class="wide-btn-flex   btn-full-tablet blue"                 (click)="resolveAndCloseCallback.emit()">Erledigen & Schließen</button> }
    @if (resolveAndNext       ) { <button class="wide-btn-flex   btn-full-tablet green"                (click)="resolveAndNextCallback.emit()" >Erledigen & Weiter   </button> }
  }
</div>
</div>
